import React from "react";

export interface InputProps
    extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
    name: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(function Input(
    {
        className = "field-control__input",
        autoComplete = "off",
        type = "text",
        placeholder = " ",
        ...props
    },
    ref
) {
    return (
        <input
            ref={ref}
            className={className}
            autoComplete={autoComplete}
            type={type}
            placeholder={placeholder}
            {...props}
        />
    );
});

export default Input;
